export function selectionOrder<T>(selectedIds: T[], id: T): number | undefined {
  const index = selectedIds.indexOf(id);

  return index === -1 ? undefined : index + 1;
}
